export const getStyles = () => ({
  content: {
    '& .bold': {
      fontWeight: 900,
    },
  },
  chooseList: {
    marginBottom: 20,
    paddingBottom: 10,
  },
});
